import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { Form } from 'antd';
import { BasicComparisonNodeModel } from '../../models';
import { useNodeComparisonForm } from '../../hooks';
import { ContractComparisonPanelsRenderer } from '..';
import './BasicComparisonRenderer.less';

interface Props {
    comparisonNode: BasicComparisonNodeModel;
}

const BasicComparisonRenderer: React.FC<Props> = ({ comparisonNode }) => {
    const { form, formKey, onValuesChange } = useNodeComparisonForm(
        comparisonNode.newNode,
        comparisonNode.previousNode
    );

    const getNewInputById = React.useCallback(
        (inputId: string) => comparisonNode.newNode?.getInputById(inputId),
        [comparisonNode.newNode]
    );

    const getPreviousInputById = React.useCallback(
        (inputId: string) => comparisonNode.previousNode?.getInputById(inputId),
        [comparisonNode.previousNode]
    );

    return (
        <div className="basic-comparison-renderer">
            <Form id={comparisonNode.nodeId} key={formKey} form={form} onValuesChange={onValuesChange}>
                <div className="basic-comparison-panels-container">
                    <ContractComparisonPanelsRenderer
                        nodeId={comparisonNode.nodeId}
                        panels={comparisonNode.panels}
                        contractChangeTracker={comparisonNode.contractChangeTracker}
                        getNewInputById={getNewInputById}
                        getPreviousInputById={getPreviousInputById}
                    />
                </div>
            </Form>
        </div>
    );
};

export default observer(BasicComparisonRenderer);
